export class Comment {
    Id: number;
    Name: string;
    Stars: Number;
    CommentMsg: string;
    UserEmail: string;
    ProductId: number;
    Updated: Date;
    Created: Date;
    Active: boolean;
  }